module.exports = __webpack_public_path__ + "media/images/icons/flags/CN-f98f38dccbf5df520b65a2ff1837e135.svg";